import { createContext } from "react";

import { getCurrentPortalType, type PortalType } from "utilities/portal/portal";

export interface IPortalInfo {
    rootPortal: PortalType;
    currentPortal: PortalType;
}

export const PortalInfoContext = createContext<IPortalInfo>({
    rootPortal: getCurrentPortalType(),
    currentPortal: getCurrentPortalType(),
});
